import { useState, useCallback, useEffect } from 'react';
import axiosInstance from '../../api/axiosInstance';
import './Turnos.css';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Loader from '../../components/loading/Loader';
import swal from '../../utils/swal';


import CancelIcon from '@mui/icons-material/Cancel';
import PersonIcon from '@mui/icons-material/Person';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventIcon from '@mui/icons-material/Event';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import CambioTurnoSelector from '../../components/cambioTurno/CambioTurnoSelector';

function obtenerNombreServicio(turno) {
    return turno.especialidad?.nombre ?? turno.practica?.nombre ?? '-';
}

function Turnos() {
    const { user } = useAuth();
    const usuarioId = user?.usuarioId;

    const [turnos, setTurnos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mostrarModalCancelar,setMostrarModalCancelar] = useState(false);
    const [turnoSeleccionado,setTurnoSeleccionado] = useState(null);
    const [motivoCancelacion,setMotivoCancelacion] = useState('');
    const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date());
    const [turnosDelDia, setTurnosDelDia] = useState([]);
    const [mostrarModalTurnos, setMostrarModalTurnos] = useState(false);
    const [mostrarModalCambio, setMostrarModalCambio] = useState(false);
    const [turnosCambioDisponibles, setTurnosCambioDisponibles] = useState([]);
    const [turnoCambioSeleccionado, setTurnoCambioSeleccionado] = useState(null);
    const [cargandoTurnosCambio, setCargandoTurnosCambio] = useState(false);
    const [errorCambio, setErrorCambio] = useState('');
    const [procesando, setProcesando] = useState(false);
    const navigate = useNavigate();
    
    const cargarTurnos = useCallback(async() => {
            try {
                const res = await axiosInstance.get(
                    `/turnos/paciente?usuarioId=${usuarioId}`
                );
                setTurnos(res.data.data);
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        },[usuarioId]);

    useEffect(() =>{
        cargarTurnos();
    },[cargarTurnos])

    useEffect(() => {
    const filtrados = turnos.filter(turno => {
        const fechaTurno = new Date(turno.fechaHora);

        return (
            fechaTurno.getDate() === fechaSeleccionada.getDate() &&
            fechaTurno.getMonth() === fechaSeleccionada.getMonth() &&
            fechaTurno.getFullYear() === fechaSeleccionada.getFullYear()
        );
    });

        setTurnosDelDia(filtrados);
    }, [turnos, fechaSeleccionada])

    useEffect(() => {

    const handleEscape = (e) => {

        if (e.key === 'Escape') {
            setMostrarModalTurnos(false);
            setMostrarModalCancelar(false);
            setMostrarModalCambio(false);
        }

    };

        window.addEventListener('keydown', handleEscape);

    return () => {
        window.removeEventListener('keydown', handleEscape);
    };

    }, []);

    async function confirmarCancelacion(){
        setProcesando(true);
        try{
            await axiosInstance.patch(`/turnos/${turnoSeleccionado._id}/cancelar`,
                { motivo: motivoCancelacion }

        );

        await cargarTurnos();

        setMotivoCancelacion('');
        setMostrarModalCancelar(false);
        setTurnoSeleccionado(null);
        } catch(err) {
            const mensaje = err?.response?.data?.message
                ?? 'No se pudo cancelar el turno.';
            await swal.fire({ icon: 'error', title: 'Error', text: mensaje, confirmButtonColor: '#db1414' });
        } finally {
            setProcesando(false);
        }
    }

    async function abrirModalCambio(turno) {
        setTurnoSeleccionado(turno);
        setTurnoCambioSeleccionado(null);
        setTurnosCambioDisponibles([]);
        setErrorCambio('');
        setMostrarModalTurnos(false);
        setMostrarModalCambio(true);
        setCargandoTurnosCambio(true);

        try {
            const res = await axiosInstance.get(`/turnos/${turno._id}/cambio_fecha/disponibles`);
            setTurnosCambioDisponibles(res.data.data ?? []);
        } catch (err) {
            const mensaje = err.response?.data?.message ?? 'No se pudieron consultar los turnos disponibles.';
            setErrorCambio(mensaje);
        } finally {
            setCargandoTurnosCambio(false);
        }
    }

    async function confirmarCambio() {
        if (!turnoSeleccionado || !turnoCambioSeleccionado) return;

        setProcesando(true);
        setErrorCambio('');

        try {
            await axiosInstance.patch(
                `/turnos/${turnoSeleccionado._id}/cambio_fecha/solicitar`,
                { nuevaFechaHora: turnoCambioSeleccionado.fechaHora }
            );

            await cargarTurnos();
            setMostrarModalCambio(false);
            setTurnoSeleccionado(null);
            setTurnoCambioSeleccionado(null);
            setTurnosCambioDisponibles([]);
        } catch (err) {
            const mensaje = err.response?.data?.message ?? 'No se pudo solicitar el cambio de turno.';
            setErrorCambio(mensaje);
        } finally {
            setProcesando(false);
        }
    }


    if (loading) return <Loader mensaje="Cargando turnos..." />;

    return (
        <div className="turnos">

            <header className="turnos__section-header">
                <div>
                    MIS TURNOS
                </div>

                <div className="turnos-toolbar">
                    <button
                        className="btn-solicitudes-turnos"
                        onClick={() => navigate('/solicitudes-cambio')}
                    >
                        Solicitudes de Cambio
                    </button>
                </div>
            </header>

            <section className="turnos__section">

                {mostrarModalTurnos && (
                    <div
                        className="modal-overlay"
                        onClick={() => setMostrarModalTurnos(false)}
                    >
                        <div
                            className="modal"
                            onClick={(e) => e.stopPropagation()}
                        >

                            <h3>
                                Turnos del {fechaSeleccionada.toLocaleDateString('es-AR')}
                            </h3>

                            <div className="modal-scroll">
                                {turnosDelDia.length === 0 ? (
                                    <p>No hay turnos para este día.</p>
                                ) : (
                                    turnosDelDia.map(turno => (
                                        <div
                                            key={turno._id}
                                            className="turno-modal-card"
                                        >
                                            <div className="turnos__row">
                                                <EventIcon className="icon" />
                                                <span>
                                                    Hora:{' '}
                                                    {new Date(turno.fechaHora).toLocaleTimeString('es-AR', {
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    })}
                                                </span>
                                            </div>

                                            <div className="turnos__row">
                                                <PersonIcon className="icon" />
                                                <span>
                                                    Médico: {turno.medico?.nombre}
                                                </span>
                                            </div>

                                            <div className="turnos__row">
                                                <LocationOnIcon className="icon" />{' '}
                                                <span>
                                                    Sede: {turno.sede?.nombre}
                                                </span>
                                            </div>

                                            <div className="turnos__row">
                                                <LocalHospitalIcon className="icon" />{' '}
                                                <span>
                                                    {obtenerNombreServicio(turno)}
                                                </span>
                                            </div>

                                            <p className={`estado estado--${turno.estado.toLowerCase()}`}>
                                                <strong>{turno.estado}</strong>
                                            </p>

                                            <div className="turnos__actions">

                                                <button
                                                    className="btn btn-danger"
                                                    onClick={() => {
                                                        setTurnoSeleccionado(turno);
                                                        setMostrarModalTurnos(false);
                                                        setMostrarModalCancelar(true);
                                                    }}
                                                >
                                                    <CancelIcon fontSize="small" />
                                                    Cancelar
                                                </button>

                                                <button
                                                    className="btn btn-warning"
                                                    onClick={() => abrirModalCambio(turno)}
                                                >
                                                    <EditCalendarIcon fontSize="small" />
                                                    Cambio
                                                </button>

                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>

                            <div className="modal-actions">
                                <button
                                    className="btn"
                                    onClick={() => setMostrarModalTurnos(false)}
                                >
                                    Cerrar
                                </button>
                            </div>

                        </div>
                    </div>
                )}

                <div className="turnos__calendar">
                    <Calendar
                        onChange={(value) => {
                            setFechaSeleccionada(value);
                            setMostrarModalTurnos(true);
                        }}
                        value={fechaSeleccionada}
                        minDate={new Date()}
                        locale="es-AR"
                        prevLabel="Anterior"
                        nextLabel="Siguiente"
                        prev2Label={null}
                        next2Label={null}
                        minDetail="year"
                        maxDetail="month"
                        formatShortWeekday={(_, date) =>
                            date.toLocaleDateString('es-AR', { weekday: 'short' }).replace('.', '')
                        }
                        tileClassName={({ date, view }) => {
                            if (view !== 'month') return null;

                            const tieneTurnos = turnos.some(turno => {
                                const fechaTurno = new Date(turno.fechaHora);

                                return (
                                    fechaTurno.getDate() === date.getDate() &&
                                    fechaTurno.getMonth() === date.getMonth() &&
                                    fechaTurno.getFullYear() === date.getFullYear()
                                );
                            });

                            return tieneTurnos ? 'turnos__tile--con-turnos' : null;
                        }}
                        tileContent={({ date, view }) => {

                            if (view !== 'month') return null;

                            const cantidad = turnos.filter(turno => {

                                const fechaTurno = new Date(turno.fechaHora);

                                return (
                                    fechaTurno.getDate() === date.getDate() &&
                                    fechaTurno.getMonth() === date.getMonth() &&
                                    fechaTurno.getFullYear() === date.getFullYear()
                                );

                            }).length;

                            return cantidad > 0
                                ? <div className="badge-turnos">{cantidad}</div>
                                : null;
                        }}
                    />
                </div>

            </section>

            {mostrarModalCancelar && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h3>Cancelar Turno</h3>

                        <textarea
                        value={motivoCancelacion}
                        onChange={e => setMotivoCancelacion(e.target.value)}
                        placeholder="Motivo de cancelación"
                        rows={4}
                        />

                        <div className="modal-actions">

                            <button
                            className="btn"
                            onClick={() => {
                                setMostrarModalCancelar(false);
                                setMostrarModalTurnos(true);
                                setMotivoCancelacion('');
                            }}
                            disabled={procesando}
                            >
                                Volver
                            </button>

                            <button
                                className="btn btn-danger"
                                onClick={confirmarCancelacion}
                                disabled={!motivoCancelacion.trim() || procesando}
                            >
                                {procesando ? <Loader inline /> : 'Confirmar Cancelación'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {mostrarModalCambio && (
                <div
                    className="modal-overlay"
                    onClick={() => setMostrarModalCambio(false)}
                >
                    <div
                        className="modal modal-cambio"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3>Solicitar cambio de turno</h3>

                        <div className="turno-cambio-resumen">
                            <div className="turnos__row">
                                <EventIcon className="icon" />
                                <span>
                                    Turno actual:{' '}
                                    {new Date(turnoSeleccionado.fechaHora).toLocaleString('es-AR', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                </span>
                            </div>

                            <div className="turnos__row">
                                <PersonIcon className="icon" />
                                <span>Médico: {turnoSeleccionado.medico?.nombre}</span>
                            </div>

                            <div className="turnos__row">
                                <LocationOnIcon className="icon" />
                                <span>Sede: {turnoSeleccionado.sede?.nombre}</span>
                            </div>
                        </div>

                        <div className="modal-scroll">
                            {cargandoTurnosCambio ? (
                                <Loader mensaje="Buscando turnos disponibles..." />
                            ) : errorCambio ? (
                                <p className="turnos-error">{errorCambio}</p>
                            ) : turnosCambioDisponibles.length === 0 ? (
                                <p>No hay turnos disponibles para solicitar el cambio.</p>
                            ) : (
                                <CambioTurnoSelector
                                    turnos={turnosCambioDisponibles}
                                    seleccionado={turnoCambioSeleccionado}
                                    onSelect={setTurnoCambioSeleccionado}
                                />
                            )}
                        </div>

                        <div className="modal-actions">
                            <button
                                className="btn"
                                onClick={() => {
                                    setMostrarModalCambio(false);
                                    setMostrarModalTurnos(true);
                                    setTurnoCambioSeleccionado(null);
                                    setErrorCambio('');
                                }}
                                disabled={procesando}
                            >
                                Volver
                            </button>

                            <button
                                className="btn btn-warning"
                                onClick={confirmarCambio}
                                disabled={!turnoCambioSeleccionado || procesando}
                            >
                                {procesando ? <Loader inline /> : 'Solicitar cambio'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}
export default Turnos;
